import { StoreState } from '../store-interfaces';

export const chatWidgetTroubleshootingLastResultSelector = (
  state: StoreState,
) => state.chatWidgetTroubleshooting.lastResult;

export const chatWidgetTroubleshootingNoIssuesMounted = (state: StoreState) =>
  state.chatWidgetTroubleshooting.noIssues;

export const chatWidgetTroubleshootingLastResultTimeSelector = (
  state: StoreState,
) => state.chatWidgetTroubleshooting.lastResultTime;
